export function determineLocale(): string {
  let locale = 'de_DE';
  if (window.Liferay) {
    locale = window.Liferay.ThemeDisplay.getLanguageId() || locale;
  }
  return locale.replace('-', '_');
}
